const loadCalcFeatures = () => {
    window.reciverCurrency && window.reciverCurrency();
}
if (/complete|interactive|loaded/.test(document.readyState)) {
    loadCalcFeatures();
} else {
    window.addEventListener("load", loadCalcFeatures);
}